import Currency from '@/components/base/currency/currency';
import TextSkeleton from '@/components/base/skeleton/text-skeleton';
import { useTranslations } from 'next-intl';

interface Props {
  price: number | undefined;
  isLoading?: boolean;
}

export const EstimatedPrice = ({ price, isLoading }: Props) => {
  const t = useTranslations('navigation.fly_basket');
  if (isLoading) {
    return <EstimatedPriceSkeleton />;
  }

  return (
    <div className="s:py-m pt-l pb-m text-center s:text-right text-default text-large">
      {t('estimated_total_price')}:
      <Currency
        className="inline-block text-large-bold text-strong"
        amount={price}
      />
    </div>
  );
};

const EstimatedPriceSkeleton = () => {
  const t = useTranslations('navigation.fly_basket');

  return (
    <div className="flex items-center justify-center gap-2 no-flex-gap:space-x-2 s:py-m pt-l pb-m text-center s:text-right text-default text-large">
      {t('estimated_total_price')}:
      <TextSkeleton className="inline-block w-clickable-large" />
    </div>
  );
};

EstimatedPrice.Skeleton = EstimatedPriceSkeleton;
